import { TimeBillingComponentKeyEnum } from "@src/__generated__/graphql";

export const COMPONENT_KEYS_ORDER = {
  [TimeBillingComponentKeyEnum.InvoicedOurwork]: 0,
  [TimeBillingComponentKeyEnum.InvoicedExpenses]: 1,
  [TimeBillingComponentKeyEnum.Prepayment]: 2,
  [TimeBillingComponentKeyEnum.ExpensesOwbi]: 3,
  [TimeBillingComponentKeyEnum.ExpensesEbi]: 4,
};
